 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML01_COVER from '@/components/xhtml/01_Cover'
 import XHTML02_TITLEPAGE from '@/components/xhtml/02_Titlepage'
 import XHTML03_COPYRIGHT from '@/components/xhtml/03_Copyright'
 import XHTML04_CONTENTS from '@/components/xhtml/04_Contents'
 import XHTML05_ACKNOWLEDGEMENTS from '@/components/xhtml/05_Acknowledgements'
 import XHTML06_THE_PLEASURES_OF_TEA from '@/components/xhtml/06_The_Pleasures_of_Tea'
 import XHTML07_GROWING_TEA from '@/components/xhtml/07_Growing_Tea'
 import XHTML08_THE_HISTORY_OF_TEA from '@/components/xhtml/08_The_History_of_Tea'
 import XHTML09_STYLES_AND_CUSTOMS_TODAY from '@/components/xhtml/09_Styles_and_Customs_Today'
 import XHTML10_CHOOSING_AND_USING_TEA from '@/components/xhtml/10_Choosing_and_Using_Tea'
 import XHTML11_A_PERFECT_CUP_OF_TEA from '@/components/xhtml/11_A_Perfect_Cup_of_Tea'
 import XHTML13_CHAPTER01_HEAD from '@/components/xhtml/13_Chapter01_Head'
 import XHTML14_CHAPTER01 from '@/components/xhtml/14_Chapter01'
 import XHTML16_CHAPTER02_HEAD from '@/components/xhtml/16_Chapter02_Head'
 import XHTML17_CHAPTER02 from '@/components/xhtml/17_Chapter02'
 import XHTML19_CHAPTER03_HEAD from '@/components/xhtml/19_Chapter03_Head'
 import XHTML20_CHAPTER03 from '@/components/xhtml/20_Chapter03'
 import XHTML22_CHAPTER04_HEAD from '@/components/xhtml/22_Chapter04_Head'
 import XHTML23_CHAPTER04 from '@/components/xhtml/23_Chapter04'
 import XHTML24_INDEX from '@/components/xhtml/24_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/01_Cover",
 			"name" : "xhtml/01_Cover",
 			"component" : XHTML01_COVER
 		},
 		{
 			"path" : "/xhtml/02_Titlepage",
 			"name" : "xhtml/02_Titlepage",
 			"component" : XHTML02_TITLEPAGE
 		},
 		{
 			"path" : "/xhtml/03_Copyright",
 			"name" : "xhtml/03_Copyright",
 			"component" : XHTML03_COPYRIGHT
 		},
 		{
 			"path" : "/xhtml/04_Contents",
 			"name" : "xhtml/04_Contents",
 			"component" : XHTML04_CONTENTS
 		},
 		{
 			"path" : "/xhtml/05_Acknowledgements",
 			"name" : "xhtml/05_Acknowledgements",
 			"component" : XHTML05_ACKNOWLEDGEMENTS
 		},
 		{
 			"path" : "/xhtml/06_The_Pleasures_of_Tea",
 			"name" : "xhtml/06_The_Pleasures_of_Tea",
 			"component" : XHTML06_THE_PLEASURES_OF_TEA
 		},
 		{
 			"path" : "/xhtml/07_Growing_Tea",
 			"name" : "xhtml/07_Growing_Tea",
 			"component" : XHTML07_GROWING_TEA
 		},
 		{
 			"path" : "/xhtml/08_The_History_of_Tea",
 			"name" : "xhtml/08_The_History_of_Tea",
 			"component" : XHTML08_THE_HISTORY_OF_TEA
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js